import React from "react";

export const NotFound = () => {
  return (
    <div className="container">
      <h1 className="text-center">
        {" "}
        Error
        <span className="text-danger"> 404 </span>
        <br />
        <small>Oops...Sorry not Found</small>
      </h1>
    </div>
  );
};
